/**
 * 条件分岐の分岐元と分岐先を対応づける通し番号。
 *
 * ヘッダーでは、条件分岐を持つ質問の見出しにチップとして番号を出し、その質問の帯にも同じ番号を出す。
 * 帯は分岐元の列から離れた位置に出るため、番号が無いとどの列の分岐なのか読み取れない。
 *
 * 番号は質問に対して1つ振る。1つの質問が複数の条件分岐を持つ場合(「はい」の場合と「いいえ」の場合など)、
 * 帯は複数になるがいずれも同じ番号になる。
 *
 * 0 始まりの columnIndex(並び替えの位置)と紛らわしいので index とは呼ばない。表示用の 1 始まりの番号。
 */

import type { TableDisplayColumn } from './tableDisplayColumn'

/**
 * 条件分岐を持つ質問に、ヘッダー左から順に 1 始まりの番号を振る。
 *
 * 前提: displayColumns は getTableDisplayColumns が返す深さ優先の並び。分岐質問の列は必ず分岐元の質問より
 * 後ろに現れ、質問の並び順とその質問の最初の分岐質問の列の並び順は一致する。
 * よって分岐質問の列を左から見て親質問を初出順に採番すれば、ヘッダーの見た目どおりの番号になる。
 * 分岐質問を持たない条件分岐も列として現れるため、その場合も分岐元に番号が振られる。
 */
export const getLogicNumberByQuestionId = (
  displayColumns: TableDisplayColumn[],
): ReadonlyMap<number, number> => {
  const logicNumberByQuestionId = new Map<number, number>()
  for (const column of displayColumns) {
    if (column.kind !== 'branch') continue
    if (logicNumberByQuestionId.has(column.parentQuestionId)) continue
    logicNumberByQuestionId.set(
      column.parentQuestionId,
      logicNumberByQuestionId.size + 1,
    )
  }
  return logicNumberByQuestionId
}
